import React from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import NavigationAlt from "./NavigationAlt";
import { Footer } from "./Footer";
import HiddenImage from "../img/ImagePreview.jpg";

export const ContactPage = () => {
  return (
    <div data-aos="fade-in">
      <header>
        <NavigationAlt />
      </header>
      <Container fluid id="contact" as="section" className="contact-page">
        <Container>
          <Row className="contact">
            <Col sm="12" md="12" lg="5">
              <h2 data-aos="fade-left">
                Get in <span>Contact</span>
              </h2>
              <p data-aos="fade-right">
                Looking for a sessions drummer for your next gig, maybe you are
                looking for drum lessons or a drummer for your upcoming track,
                then I’m your guy! Contact me today with information regarding
                what you need and I will get back to you as soon as possible.
              </p>
            </Col>
            <Col sm="12" md="12" lg="2"></Col>
            <Col sm="12" md="12" lg="5">
              <Form
                data-netlify="true"
                name="contact"
                method="POST"
                className="w-75 mainForm"
                netlify-honeypot="bot-field"
              >
                <p className="d-none">
                  <label>
                    Don’t fill this out if you’re human:{" "}
                    <input name="bot-field" />
                  </label>
                </p>

                <input type="hidden" name="form-name" value="contact" />

                <Form.Group className="mb-3">
                  <Form.Label htmlFor="name">Full Name</Form.Label>
                  <Form.Control type="text" id="name" name="name" />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label htmlFor="email">Email address</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="name@example.com"
                    id="email"
                    name="email"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label htmlFor="message">Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    id="message"
                    name="message"
                  />
                </Form.Group>
                <Button type="submit">
                  Submit
                </Button>
              </Form>
              <img src={HiddenImage} className="d-none" alt="placeholder" />
            </Col>
          </Row>
        </Container>
      </Container>
      <Footer />
    </div>
  );
};
